export const headers = {
  initialHeaders: [
    {
      title: "Nombre del empleado",
      field: "employee",
      child: "fullName",
    },
    {
      title: "Fecha de creación",
      field: "creationDate",
      child: null,
    },
    {
      title: "Fecha inicial",
      field: "initRefundDate",
      child: null,
    },
    {
      title: "Fecha final",
      field: "endRefundDate",
      child: null,
    },
    {
       title: "Regional",
       field: "employee",
       child: "regional",
    }
  ],
  otherHeaders: [
    {
      title: "Primer nombre",
      field: "employee",
      child: "firstName",
    },
    {
      title: "Segundo nombre",
      field: "employee",
      child: "secondName",
    },
    {
      title: "Primer apellido",
      field: "employee",
      child: "surname",
    },
    {
      title: "Segundo apellido",
      field: "employee",
      child: "secondSurname",
    },
    {
      title: "Género",
      field: "employee",
      child: "gender",
    },
    
    {
      title: "Fecha inicial",
      field: "initRefundDate",
      child: null,
    },
    {
      title: "Fecha final",
      field: "endRefundDate",
      child: null,
    },
    {
      title: "Estado",
      field: "status",
      child: null
    }
  ],
};

export const defaultSearchValues = {
  employeeSurname: null,
  licenseStartDate: null,
  regional: null,
  employeeName: null,
  licenseEndDate: null,
};